export const baseURL = process.env.NODE_ENV === 'development' 
                        ? "http://localhost:3032" 
                        : window.location.href.split(".")[2] === "staging"
                        ?"https://atci.commsbuilder.staging.accenture.com/commsbuilderstage-apis"
                        :"https://atci.commsbuilder.accenture.com/commsbuilder-apis";

